import React, {useEffect, useState} from "react";
import Button from "../../components/v2/Button";
import StepperCar from "../../components/v2/StepperCar";
import Input from "../../components/v2/Input";
import useValetStore from "./hooks/useValetStore";
import {ValetSteps} from "./constants/ValetSteps";
import moment from "moment";
import Alert, {ERROR} from "../../components/v2/Alert";
import KucPhoneInput from "../../components/v2/KucPhoneInput";
import {RouteType} from "./constants/RouteType";
import Swal from "sweetalert2";
import {useTranslation} from "react-i18next";

export default function ValetYourOrder({
                                           backClickedHandler,
                                       }) {

    const {
        callGet,
        valetIntent,
        setTravelData,
        setStep,
        userData,
        isStandAlone
    } = useValetStore();

    const [date, setDate] = useState(userData?.travel?.date ?? '');
    const [time, setTime] = useState(userData?.travel?.time ?? '');
    const [retrieveHour, setRetrieveHour] = useState(userData?.travel?.retrieveHour ?? '');
    const [phone, setPhone] = useState(userData?.travel?.phone ?? userData?.identity?.phone ?? '');
    const [validPhone, setValidPhone] = useState();

    const [comment, setComment] = useState(userData?.travel?.comment ?? '');
    const [deliveryContactName, setDeliveryContactName] = useState(userData?.travel?.deliveryContactName ?? '');
    const [deliveryContactPhone, setDeliveryContactPhone] = useState(userData?.travel?.deliveryContactPhone ?? '');
    const [validDeliveryContactPhone, setValidDeliveryContactPhone] = useState();
    const [errorMessage, setErrorMessage] = useState(null);

    const formRef = React.useRef();

    const {t} = useTranslation('common')

    const checkDateAndTime = () => {
        var goDateTime = moment(date + ' ' + time, 'YYYY-MM-DD HH:mm');
        var now = moment();

        var retrieveDateTime = null;
        if (retrieveHour != '') {
            retrieveDateTime = moment(date + ' ' + retrieveHour, 'YYYY-MM-DD HH:mm');
        }


        // On vérifie que l'heure est pas inférieure à celle actuelle
        if (goDateTime.isBefore(now)) {
            setErrorMessage(t('valet.order.text'));
            return;
        }

        // On vérifie si la date est plus loin que l'heure actuelle plus une heure
        if (goDateTime.isBefore(now.add(1, 'hour'))) {
            setErrorMessage(<div>{t('valet.order.text2')}<br/>{t('valet.order.text3')}</div>);
            return;
        }

        // On vérifie l'heure de retour, doit être postérieure à l'heure de collecte
        if (retrieveDateTime != null && retrieveDateTime.isBefore(goDateTime)) {
            setErrorMessage(t('valet.order.text4'));
            return;
        }

        setErrorMessage(null);
        return;
    }

    useEffect(() => {
        if (date != '' && time != '') {
            checkDateAndTime();
        }
    }, [
        date, time, retrieveHour
    ]);

    useEffect(() => {
        if (!isStandAlone && phone == '') {
            // Dans ce cas, on récupère éventuellement le numéro de téléphone du compte
            callGet('account', (successData) => {
                setPhone(successData.user.phone);
            }, (failResultData) => {
                Swal.fire({
                    text: failResultData.message,
                    icon: 'error',
                });
            });
        }
    }, [isStandAlone]);

    const nextClickedHandler = (e) => {
        if (!formRef.current.reportValidity()) {
            return;
        }

        if (validPhone === false) {
            setErrorMessage(t('valet.order.text5'));
            return;
        }

        if (validDeliveryContactPhone === false) {
            setErrorMessage(t('valet.order.text6'));
            return;
        }

        // NB on ne sauvegarde rien pour le moment, ce sera plus tard
        setTravelData(
            {
                date: date,
                time: time,
                retrieveHour: retrieveHour,
                phone: phone,
                comment: comment,
                deliveryContactName: deliveryContactName,
                deliveryContactPhone: deliveryContactPhone
            }
        )
        setStep(ValetSteps.SUMMARY);
    }

    return <div className="h-full flex flex-col p-4 gap-4">
        <StepperCar value={70}/>
        <div className="text-white text-[30px] font-bold">
            {t('valet.order.text7')}
        </div>
        <form ref={formRef}>
            <fieldset className="border border-solid border-gray-300 p-3 rounded-2xl mt-4">
                <legend className="text-sm">&nbsp;{t('valet.order.text8')}&nbsp;</legend>
                <Input id="date"
                       label={t('valet.order.text9')}
                       type="date"
                       placeholder={t('valet.order.text10')}
                       value={date}
                       required={true}
                       onChange={(e) => setDate(e)}
                />
                <Input id="hour" label={t('valet.order.text11')} placeholder={t('valet.order.text12')}
                       type="time"
                       value={time}
                       required={true}
                       onChange={(e) => setTime(e)}
                />
                {
                    userData.travel.routeType === RouteType.GOING_AND_COMING ?
                        <Input id="retrieveHour" label={t('valet.order.text13')} placeholder={t('valet.order.text14')}
                               type="time"
                               value={retrieveHour}
                               required={true}
                               onChange={(e) => setRetrieveHour(e)}
                        />
                        : null
                }
                <KucPhoneInput id="phone" label={t('valet.order.text15')} placeholder={t('valet.order.text16')}
                               fullWidth
                               value={phone}
                               required={true}
                               onChange={(value, isValid) => {
                                   setPhone(value);
                                   setValidPhone(isValid);
                               }}
                />
                <Input id="comment" label={t('valet.order.text17')}
                       placeholder={t('valet.order.text18')}
                       value={comment}
                       onChange={(e) => setComment(e)}
                />
            </fieldset>

            <fieldset className="border border-solid border-gray-300 p-3 rounded-2xl mt-4">
                <legend className="text-sm">&nbsp;{t('valet.order.text19')}&nbsp;</legend>
                <Input id="deliveryContactName" label={t('valet.order.text20')}
                       placeholder={t('valet.order.text21')}
                       value={deliveryContactName}
                       required={true}
                       onChange={(e) => setDeliveryContactName(e)}
                />

                <KucPhoneInput id="deliveryContactPhone" label={t('valet.order.text22')}
                               placeholder={t('valet.order.text23')}
                               fullWidth
                               value={deliveryContactPhone}
                               required={true}
                               onChange={(value, isValid) => {
                                   setDeliveryContactPhone(value);
                                   setValidDeliveryContactPhone(isValid);
                               }}
                />
            </fieldset>
        </form>
        {errorMessage != null ?
            <Alert type={ERROR}
                // label="Horaire incorrecte"
                   text={errorMessage}
            /> : null
        }
        <div className="grow">
        </div>
        <div className="flex gap-4">
            <Button outline text={<div>
                <div>{t('valet.order.text24')}</div>
                <div
                    className="text-sm mt-[-8px]">{isStandAlone ? <>{t('valet.order.text25')}</> : <>{t('valet.order.text26')}</>}</div>
            </div>} clickHandler={backClickedHandler}/>
            <Button text={t('valet.order.text27')} clickHandler={nextClickedHandler}/>
        </div>
    </div>
}